import { Modal, Text, Group, Button } from '@mantine/core'

interface ConfirmModalProps {
  opened: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  message?: string
  loading?: boolean
}

export default function ConfirmModal({
  opened,
  onClose,
  onConfirm,
  title = 'Устгах уу?',
  message = 'Энэ үйлдлийг буцаах боломжгүй.',
  loading = false,
}: ConfirmModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} title={title} centered size="sm">
      <Text size="sm" c="dimmed" mb="lg">{message}</Text>
      <Group justify="flex-end">
        <Button variant="default" onClick={onClose}>Болих</Button>
        <Button color="red" onClick={onConfirm} loading={loading}>Устгах</Button>
      </Group>
    </Modal>
  )
}
